// Bootstrap JS and CSS
import 'bootstrap';
import './../css/main.scss';

// Bootstrap Popover
import './vendor/popover';

// Bootstrap Tooltip
import './vendor/tooltip';
